import { render, staticRenderFns } from "./AssessmentTrendline.vue?vue&type=template&id=20506a20&scoped=true"
import script from "./AssessmentTrendline.vue?vue&type=script&lang=js"
export * from "./AssessmentTrendline.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTrendline.vue?vue&type=style&index=0&id=20506a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20506a20",
  null
  
)

export default component.exports